
// initial state
import {getIndexById} from "../util/paginate";

const state = {
	selectedItem: null, // 选中
	items: [],
	total: 0,
}

// getters
const getters = {
	// TODO:
}

// mutations
const mutations = {
	selectPrescriptionItem(state, item) {
		state.selectedItem = item
	},
	unselectPrescriptionItem(state) {
		state.selectedItem = null
	},
	traversePrescriptionItems(state) {
		const { items } = state
// 		if (items && items.length) {
// 			if (state.selectedItem === null || state.selectedItem === undefined) {
// 				let item = items[0]
// 				this.commit('selectPrescriptionItem', item)
// 			}
// 		}
	},
	addPrescriptionItem(state, item) {
		state.items.push(item)
		this.commit('traversePrescriptionItems')
	},
	modifyPrescriptionItem(state, item) {
		const { items } = state
		let index = getIndexById(items, item.id)
		state.items.splice(index, 1, item)

		// 当前选中的地址和要修改的地址相同时，更新当前选中的地址
		let selectedItem = state.selectedItem
		if (selectedItem && selectedItem.id && selectedItem.id === item.id) {
			this.commit('selectPrescriptionItem', item)
		}
		this.commit('traversePrescriptionItems')
	},
	savePrescriptionItems(state, items) {
		state.items = items
		this.commit('traversePrescriptionItems')
	},
	removePrescriptionItem(state, id) {
		const { items } = state
		let index = getIndexById(items, id)
		state.items.splice(index, 1)

		// 当前选中的地址和要删除的地址相同时，当前选中的地址置为空
		let selectedItem = state.selectedItem
		if (selectedItem && selectedItem.id && selectedItem.id === id) {
			this.commit('unselectPrescriptionItem')
		}
		this.commit('traversePrescriptionItems')
	},
}

export default {
	state,
	getters,
	mutations,
	// actions
}
